import { ResponsiblePartyEnum } from '@/types/graphql/schemaTypes';
import i18n from '@/plugins/i18n';
import { SelectOption } from '@/types/types';

export function responsiblePartyOptions(): SelectOption<string>[] {
  return [
    {
      label: i18n.t('attachments.shippio').toString(),
      value: ResponsiblePartyEnum.shippio
    },
    {
      label: i18n.t('attachments.client').toString(),
      value: ResponsiblePartyEnum.client
    }
  ];
}
